<template>
  <div
    class="cms-switch"
    :class="[
      {
        'is-disabled': disabled,
        'is-loading': loading,
        [`cms-switch--${size}`]: size
      },
      switchClass
    ]"
    role="switch"
    :aria-checked="checked"
    :aria-disabled="disabled"
    @click.prevent="handleClick"
  >
    <input
      v-if="name"
      :name="name"
      type="checkbox"
      class="cms-switch__input"
      :value="modelValue"
      :disabled="disabled"
    />
    <span class="cms-switch__core" :style="coreStyle">
      <div class="cms-switch__action">
        <i v-if="loading" class="cms-icon-loading">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path
              fill="currentColor"
              d="M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z"
            ></path>
          </svg>
        </i>
      </div>
    </span>
    <span
      v-if="activeText || inactiveText"
      class="cms-switch__label"
      :class="{ 'is-active': checked }"
    >
      <span v-if="checked">{{ activeText }}</span>
      <span v-else>{{ inactiveText }}</span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { switchProps, switchEmits } from './switch'

defineOptions({
  name: 'cms-switch' 
})

const props = defineProps(switchProps)
const emit = defineEmits(switchEmits)

// 是否选中状态
const checked = computed(() => props.modelValue === props.activeValue)

// 开关样式类
const switchClass = computed(() => ({
  'is-checked': checked.value
}))

// 开关核心样式
const coreStyle = computed(() => {
  const style: Record<string, string> = {}
  if (props.width) {
    style.width = `${props.width}px`
  }
  if (checked.value) {
    style['border-color'] = props.activeColor
    style['background-color'] = props.activeColor
  } else {
    style['border-color'] = props.inactiveColor
    style['background-color'] = props.inactiveColor
  }
  return style
})

// 处理点击事件
const handleClick = () => {
  if (props.disabled || props.loading) return
  const value = checked.value ? props.inactiveValue : props.activeValue
  emit('update:modelValue', value)
  emit('change', value)
  emit('input', value)
}
</script>

<style lang="scss">

</style>
